import { CarID } from "./Car";
import { User, UserID } from "./User";

export type CarNoteID = number;

export type CarNoteAttachmentID = number;

export enum CAR_NOTE_TYPE {
  Default = 1,
  DMS = 2
}

export interface CarNote {
  created_on: string;
  updated_on: string;
  id: CarNoteID; // Identifier of the Car Note
  note: string; // Car note
  visible_on_wo: boolean; // Note is visible on WO details page
  visible_to_mechanic: boolean; // Note is visible to Mechanic
  car_note_type_id: CAR_NOTE_TYPE; // Type of this note, Default if created in Claire, DMS if created in DMS
  dms_nr: string | null; // DMS Number of the note, if note type is DMS
  car_id: CarID; // Identifier of the car
  created_by_id: UserID; // Identifier of the user who created the note
  updated_by_id: UserID | null; // Identifier of the user who updated the note
  attachments?: CarNoteAttachment[]; // List of attachments of the car note
  created_by?: User; // User who created the note
  updated_by?: User; // User who updated the note
}

export interface CarNoteAttachment {
  created_on: string;
  updated_on: string;
  id: CarNoteAttachmentID; // Identifier of the car note attachment
  url: string; // URL of the attachment
  type: string; // File type of the attachment
  name: string; // Name of the attachment file
  car_note_id: CarNoteID; // Identifier of the car note to which this attachment belongs
  user_id: UserID; // Identifier of the user who added this attachment
  username?: string; // Name of the user who created this attachment
}
